export enum FormV2TypeEnum {
  Join = 1,
  Donation = 2,
  Renewal = 3,
  GeneralSurvey = 4,
  Prospect = 5,
}
